import { render, staticRenderFns } from "./CardDocumentAnnexes.vue?vue&type=template&id=5fe4c0f9&"
import script from "./CardDocumentAnnexes.vue?vue&type=script&lang=js&"
export * from "./CardDocumentAnnexes.vue?vue&type=script&lang=js&"
import style0 from "./CardDocumentAnnexes.vue?vue&type=style&index=0&id=5fe4c0f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports